import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner/spinner';
import { token } from '@atlaskit/tokens';
import { defineMessage, useIntl } from '@atlassian/jira-intl/src/index.tsx';

const styles = cssMap({
	container: {
		boxSizing: 'border-box',
		height: '100%',
		minHeight: 0,
		paddingTop: token('space.300'),
		paddingRight: token('space.300'),
		paddingBottom: token('space.300'),
		paddingLeft: token('space.300'),
		width: '100%',
	},
});

const loadingLabel = defineMessage({
	id: 'spa-apps-knowledge-page.loading-skeleton.label.non-final',
	defaultMessage: 'Loading Knowledge Page',
	description: 'Accessible label for a spinner shown while the knowledge page is loading.',
});

export const KnowledgePageLoadingSkeleton = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Flex xcss={styles.container} alignItems="center" justifyContent="center">
			<Spinner size="large" label={formatMessage(loadingLabel)} />
		</Flex>
	);
};
